import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useContent } from "../i18n/LanguageContext";
import { Menu, X, ChevronRight } from "lucide-react";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Header({ onOpenAccount }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { nav, ui } = useContent();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-[0_1px_0_0_#eee]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-md bg-[#16233d] flex items-center justify-center">
            <span className="font-serif-lux text-2xl text-[#b08d57] leading-none">B</span>
          </div>
          <div className="leading-tight">
            <div className="font-serif-lux text-xl text-[#16233d] font-semibold">{nav.brand}</div>
            <div className="text-[10px] tracking-[0.2em] text-[#8a8f9c]">{nav.brandSub}</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {nav.links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-sm text-[#3a4258] hover:text-[#b08d57] transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#b08d57] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-5">
          <LanguageSwitcher />
          <Link to="/login" className="text-sm text-[#3a4258] hover:text-[#b08d57] transition-colors">{ui.login}</Link>
          <button
            onClick={onOpenAccount}
            className="btn-gold rounded-md px-5 py-2.5 text-sm font-medium flex items-center gap-2"
          >
            {ui.openAccount} <ChevronRight size={16} />
          </button>
        </div>

        <button className="lg:hidden text-[#16233d]" onClick={() => setOpen((o) => !o)}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-[#eee] px-6 py-4 space-y-3">
          {nav.links.map((l) => (
            <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="block text-[#3a4258] py-1">
              {l.label}
            </a>
          ))}
          <Link to="/login" onClick={() => setOpen(false)} className="block text-[#3a4258] py-1">
            {ui.portal}
          </Link>
          <div className="py-1"><LanguageSwitcher /></div>
          <button onClick={onOpenAccount} className="btn-gold rounded-md px-5 py-2.5 text-sm font-medium w-full mt-2">
            {ui.openAccount}
          </button>
        </div>
      )}
    </header>
  );
}
